import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getIncomeStatement = ({ churchId, startDate, endDate }) => {
  return axios.get(
    `/churches/${churchId}/income-statement?start_date=${startDate}&end_date=${endDate}`
  );
};

export const useIncomeStatement = ({
  churchId,
  startDate,
  endDate,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["income-statement", churchId, startDate, endDate],
    queryFn: () => getIncomeStatement({ churchId, startDate, endDate }),
    select: data => data.result
  });
};
